


































































import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import PlanningEntryListEntry from "../../models/planningEntry/PlanningEntryListEntry";
import {Icon} from "@/helpers/icons";
import AsiBtn from "../common/AsiBtn.vue";
import AsiAvatar from "../common/AsiAvatar.vue";
import CompanySimple from "../../models/company/CompanySimple";
import UserSimple from "../../models/user/UserSimple";
import {BpwConfirmDialogDefinition} from "@/helpers/interfaces";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import PlanningEntryUpdateDialog from "@/components/planningEntry/PlanningEntryUpdateDialog.vue";
import AsiConfirmDialog from "@/components/common/AsiConfirmDialog.vue";
import {Permissions} from "@/helpers/constants";
import AsiMenuItem from "@/components/common/AsiMenuItem.vue";
import ReportCreateDialog from "@/components/report/ReportCreateDialog.vue";

@Component({
	components: {ReportCreateDialog, AsiMenuItem, AsiConfirmDialog, PlanningEntryUpdateDialog, AsiAvatar, AsiBtn}
})
export default class DailyOverviewEntry extends Vue {

	@Prop({type: Object, required: true})
	public planningEntry!: PlanningEntryListEntry;

	@Prop({type: Boolean, default: true})
	public showCompany!: boolean;

	@Prop({type: Boolean, default: true})
	public showOrder!: boolean;

	private icons = Icon;
	private updateDialogOpen = false;
	private reportCreateDialogOpen = false;

	private get hasReport(): boolean {
		return this.planningEntry !== null && this.planningEntry.hasReports;
	}

	private get isPlanning(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightPlanning);
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	@Emit('loadingChanged')
	public loadingChanged(loading: boolean): boolean {
		return loading;
	}

	@Emit('planningEntryChanged')
	public planningEntryChanged(): void {
		this.updateDialogOpen = false;
	}

	protected companyAvatarUrl(companySimple: CompanySimple): string | null {
		return CompanySimple.avatarUrlMedium(companySimple);
	}

	protected userAvatarUrl(userSimple: UserSimple): string | null {
		return UserSimple.avatarUrlMedium(userSimple);
	}

	private openUpdateDialog(value: boolean): void {
		this.updateDialogOpen = value;
	}

	private userFullName(user: UserSimple): string | null {
		return UserSimple.fullName(user);
	}

	private deletePlanningEntry(entry: PlanningEntryListEntry): void {
		if (!this.isPlanning) return;

		const confirm = this.$refs.confirm as unknown as BpwConfirmDialogDefinition;
		confirm.openDialog().then((res: boolean) => {
			if (!res) return;

			this.loadingChanged(true);
			this.$planningEntryService.delete(entry.id)
				.then(() => {
					this.planningEntryChanged();
				})
				.catch(() => {
					this.$store.commit('ui/showSnackbar', {
						message: this.$t('snackbar.deleteError'),
						color: 'error',
					} as SnackbarMessage);
				})
				.finally(() => {
					this.loadingChanged(false);
				});
		});
	}

	private showReport(): void {
		if (this.planningEntry === null || this.planningEntry.reportId === null) return;
		this.$router.push({name: 'Report', params: {id: this.planningEntry.reportId}});
	}

}
